;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { cn } from '@qogita/ui/utils/cn'
import { BaseAnchor } from '@qogita/ui/v2/base-anchor'
import { cva, VariantProps } from 'class-variance-authority'
import { ReactNode } from 'react'

const linkButtonVariants = cva(
  'rounded-sm px-6 py-4 text-center tracking-[1px]',
  {
    variants: {
      variant: {
        contained:
          'bg-button-primary text-button-primary border border-gray-800 hover:bg-gray-700 active:bg-gray-900',
        outlined:
          'border border-gray-800 text-gray-800 hover:bg-gray-50 active:shadow-gray-800',
        white:
          'bg-default text-default hover:text-default active:text-default hover:bg-gray-100 active:bg-gray-100',
      },
    },
    defaultVariants: {
      variant: 'contained',
    },
  },
)

type LinkButtonProps = VariantProps<typeof linkButtonVariants> & {
  href: string
  children: ReactNode
  openNewTab?: boolean
  className?: string
}

/**
 * CMS-specific link button primitive — not a shared UI primitive.
 * `className` is intended for layout overrides (e.g. width, alignment) only.
 * Do not use it to override visual styling; add or adjust a `variant` instead.
 */
export function LinkButton({
  href,
  children,
  variant,
  openNewTab,
  className,
}: LinkButtonProps) {
  return (
    <BaseAnchor
      href={href}
      openNewTab={openNewTab}
      className={cn(linkButtonVariants({ variant }), className)}
    >
      {children}
    </BaseAnchor>
  )
}
